<!-- [팝업] 메디컬트렌드 검색 -->
<template>
  <b-modal
    v-model="showMedicalTrendSelect"
    cancel-variant="outline-secondary"
    centered
    ok-title="추가"
    cancel-title="취소"
    size="xl"
    title="메디컬트렌드 추가"
    no-close-on-esc
    no-close-on-backdrop
    @ok.prevent="submit()"
    @close.prevent="close()"
    @cancel.prevent="close()"
  >
    <b-row>
      <b-col
        cols="12"
        md="10"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-form-input
          v-model="query.liveInfoId"
          class="el-def mr-1"
          placeholder="ID"
          style="width:10%"
        />
        <v-select
          v-model="query.isInfoPopUp"
          :options="codes.useTypeFixed"
          class="el-def mr-1"
          placeholder="처방팝업"
          :reduce="(option) => option.code"
          style="width:200px;"
        />
        <v-select
          v-model="query.isScheduleUse"
          :options="codes.useTypeFixed"
          class="el-def mr-1"
          placeholder="스케줄팝업"
          :reduce="(option) => option.code"
          style="width:200px;"
        />
        <v-select
          v-model="query.isAfterConsultPopup"
          :options="codes.useTypeFixed"
          class="el-def mr-1"
          placeholder="진료후팝업"
          :reduce="(option) => option.code"
          style="width:200px;"
        />
        <b-form-input
          v-model="query.title"
          class="el-def mr-1"
          placeholder="제목"
          style="width:40%;"
        />
        <b-form-datepicker
          id="datepicker-placeholder1"
          v-model="query.startDate"
          class="el-def mr-1"
          placeholder="게시기간(Fr)"
          style="width:200px;"
        />
        <label class="mr-25">~</label>
        <b-form-datepicker
          id="datepicker-placeholder2"
          v-model="query.endDate"
          class="el-def mr-1"
          placeholder="게시기간(To)"
          style="width:200px;"
        />
      </b-col>
      <!-- Search -->
      <b-col
        cols="12"
        md="2"
        class="d-flex align-items-center justify-content-end"
      >
        <b-button
          variant="primary"
          class="btn-search"
          @click.prevent="refetchData()"
        >
          조회
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mt-25">
      <span class="ml-25">메디컬트렌드 리스트 [{{ totalRecords }}]건</span>
    </b-row>
    <b-row class="mt-1">
      <b-table
        ref="refMedicalTrendTable"
        primary-key="id"
        :items="fetchMedicalTrends"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDesc"
        responsive
        sticky-header="460px"
        selectable
        select-mode="multi"
        class="position-relative"
        @row-selected="onRowSelectedMedicalTrend"
        @row-dblclicked="onRowDblClickedMedicalTrend"
      >
        <template #cell(isInfoPopUp)="data">
          <div
            class="text-nowrap"
            style="text-align: center;"
          >
            {{ data.value ? 'O' : 'X' }}
          </div>
        </template>
        <template #cell(isScheduleUse)="data">
          <div
            class="text-nowrap"
            style="text-align: center;"
          >
            {{ data.value ? 'O' : 'X' }}
          </div>
        </template>
        <template #cell(isAfterConsultPopup)="data">
          <div
            class="text-nowrap"
            style="text-align: center;"
          >
            {{ data.value ? 'O' : 'X' }}
          </div>
        </template>
      </b-table>
    </b-row>
  </b-modal>
</template>

<script>
import dayjs from "dayjs"
import axios from '@axios'
import { ref, onMounted, getCurrentInstance } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from "vue-select"

export default {
  components: {
    vSelect,
  },

  props: {
    showMedicalTrendSelect: {
      type: Boolean,
      required: true,
    },
    selectedValue: {
      type: Array,
      required: false,
      default: () => [],
    },
    filterType: {
      type: Number,
      required: true,
    },
  },

  setup(props, { emit }) {
    onMounted(() => {
      fetchCodes()
    })
    const instance = getCurrentInstance()
    const bvModal = instance.proxy.$bvModal

    const toast = useToast()
    const pushToast = (variant, title) => {
      let icon
      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }
      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }
    // Query Data
    const query = ref({
      liveInfoId: null,
      startDate: dayjs().add(-6, 'month').format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD'),
      isMainView: null,
      isInfoPopUp: null,
      isScheduleUse: null,
      isAfterConsultPopup: null,
      title: null,
    })
    // Query Data End.

    // Set Codes
    const codes = ref({
      useTypeFixed: [],
    })

    const fetchCodes = () => {
      axios.get("/fa/medical/codes")
        .then(rs => {
          const { useTypeFixed } = rs.data
          codes.value.useTypeFixed = useTypeFixed
          // refetchData()
        })
        .catch(() => {
          pushToast('danger', '코드 데이터를 불러오는데 실패하였습니다.')
        })
    }
    // Set Codes End.

    // Main Table Config
    const refMedicalTrendTable = ref(null)
    const sortBy = ref('liveInfoId')
    const isSortDesc = ref(true)
    // const currPage = ref(1)
    const totalRecords = ref(0)
    const tableColumns = [
      {
        key: 'liveInfoId', label: 'Id', sortable: true, thStyle: { width: '10%' },
      },
      {
        key: 'utilData', label: '활용데이터', sortable: true, thStyle: { width: '15%' },
      },
      {
        key: 'title', label: '제목', sortable: true, thStyle: { width: '30%' },
      },
      {
        key: 'isInfoPopUp', label: '처방팝업', sortable: true, thStyle: { width: '10%' },
      },
      {
        key: 'isScheduleUse', label: '스케줄팝업', sortable: true, thStyle: { width: '10%' },
      },
      {
        key: 'isAfterConsultPopup', label: '진료후팝업', sortable: true, thStyle: { width: '10%' },
      },
      { key: 'liveDate', label: '게시 기간', sortable: true },
    ]
    const sortFieldMap = {
      liveDate: 'startDate',
    }
    const refetchData = () => {
      if (refMedicalTrendTable.value) refMedicalTrendTable.value.refresh()
    }
    // watch([currPage], () => {
    //   refetchData()
    // })
    const selectedRows = ref([])
    const onRowSelectedMedicalTrend = items => {
      selectedRows.value = items
    }
    const onRowDblClickedMedicalTrend = item => {
      selectedRows.value = [item]
      submit()
    }
    // Main Table Config End.
    const fetchMedicalTrends = (ctx, callback) => {
      if (!query.value.startDate || !query.value.endDate) {
        pushToast('warning', '조회 기간을 설정하세요')
        callback([])
        totalRecords.value = 0
        return
      }

      axios.post('/fa/medical/list', {
        search: {
          query: query.value,
        },
        sort: {
          predicate: sortFieldMap[sortBy.value] || sortBy.value,
          reverse: isSortDesc.value,
        },
      })
        .then(rs => {
          const { items, totalRecord } = rs.data
          callback(items)
          totalRecords.value = totalRecord
        })
        .catch(() => {
          pushToast('danger', '데이터 조회에 실패하였습니다.')
        })
    }

    const close = () => {
      query.value = {
        liveInfoId: null,
        startDate: dayjs().add(-6, 'month').format('YYYY-MM-DD'),
        endDate: dayjs().format('YYYY-MM-DD'),
        isMainView: null,
        isInfoPopUp: null,
        isScheduleUse: null,
        isAfterConsultPopup: null,
        title: null,
      }
      emit('close', null)
    }

    const submit = () => {
      if (!selectedRows.value || selectedRows.value.length === 0) {
        pushToast('warning', '메디컬트렌드를 선택하세요')
        return
      }

      const newCount = selectedRows.value.filter(
        item => !props.selectedValue.includes(item.liveInfoId),
      ).length

      if (props.selectedValue.length + newCount > 5) {
        bvModal.msgBoxOk('활동은 약품정보/메디컬트렌드/설문조사 구분없이 최대 5개까지 추가할 수 있습니다.', {
          okTitle: '확인',
        })
        return
      }
      const selectedMedicalTrendList = []
      selectedRows.value.forEach(item => {
        selectedMedicalTrendList.push({
          filterId: item.liveInfoId,
          filterType: props.filterType,
          utilData: item.utilData,
          title: item.title,
          isInfoPopUp: item.isInfoPopUp,
          isScheduleUse: item.isScheduleUse,
          isAfterConsultPopup: item.isAfterConsultPopup,
          liveDate: item.liveDate,
          startDate: item.startDate,
          endDate: item.endDate,
        })
      })

      emit('close', selectedMedicalTrendList)
    }

    return {
      query,
      codes,
      fetchCodes,
      close,
      submit,
      refMedicalTrendTable,
      sortBy,
      // currPage,
      isSortDesc,
      totalRecords,
      tableColumns,
      refetchData,
      onRowSelectedMedicalTrend,
      onRowDblClickedMedicalTrend,
      fetchMedicalTrends,
    }
  },
}
</script>
